module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_15.eab085d0.png";